<template>
  <div>
    <v-card
      class="mx-auto"
    >
      <v-card-title>
        Projects list
        <v-spacer></v-spacer>
        <v-btn icon color="success" @click="allProjectsDialog = true">
          <v-icon>mdi-plus-circle</v-icon>
        </v-btn>
      </v-card-title>
      <v-sheet class="pa-4 primary">
        <v-text-field
          v-model="search"
          label="Search project"
          dark
          flat
          solo-inverted
          hide-details
          clearable
          clear-icon="mdi-close-circle-outline"
        ></v-text-field>
        <v-checkbox
          v-if="multiple"
          v-model="selectMultiple"
          dark
          label="Select multiple"
          hide-details
          dense
        ></v-checkbox>
      </v-sheet>
      <v-virtual-scroll
        :items="filteredProjectsList"
        item-height="60"
        min-height="60"
        max-height="500"
        :key="updateKey"
      >
        <template v-slot:default="{ item }">
          <v-list-item
            link
            :input-value="item.Project_ID === selectedProject"
            @click.prevent="setProject(item, true)"
            color="primary"
            :disabled="item.Project_ID === blockedProject || isLoading"
          >
            <v-list-item-icon>
              <v-checkbox
                v-if="selectMultiple"
                v-model="selectedProjects"
                :value="item.Project_ID"
                class="ma-0"
                dense
                hide-details
              ></v-checkbox>
              <v-icon>mdi-folder</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.Description"></v-list-item-title>
            </v-list-item-content>

            <v-list-item-action v-if="!simple && item.Project_ID === selectedProject && item.Project_ID !== blockedProject" @click.prevent="getDetailInformation">
              <v-btn icon>
                <v-icon color="primary">mdi-alpha-r-circle</v-icon>
              </v-btn>
            </v-list-item-action>
            <v-list-item-action v-if="item.Project_ID === blockedProject">
              <v-icon
                color="primary"
              >
                mdi-loading mdi-spin
              </v-icon>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-virtual-scroll>
      <v-divider v-if="selectMultiple && selectedProjects.length > 1"></v-divider>
      <v-card-actions v-if="selectMultiple && selectedProjects.length > 1">
        <v-spacer></v-spacer>
        <v-btn
          small
          color="primary"
          @click="setMultipleProjects"
        >
          Show
        </v-btn>
      </v-card-actions>
    </v-card>
    <ProjectsListSettingsDialog
      v-model="allProjectsDialog"
      @updateProjectsList="getProjectsList"
    />
    </div>
</template>
<script>
export default {
  name: 'ProjectsList',
  components: {
    ProjectsListSettingsDialog: () => import('@/components/global/ProjectsListSettingsDialog.vue')
  },
  props: {
    simple: {
      required: false,
      type: Boolean,
      default: false
    },
    multiple: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      managedProjects: [],
      search: null,
      updateKey: 1,
      gettingInformation: false,
      selectedProjects: [],
      allProjectsDialog: false,
      selectMultiple: false
    }
  },
  computed: {
    blockedProject () {
      return this.$store.getters.getBlockedProject
    },
    selectedProject () {
      return this.$store.getters.getSelectedProject
    },
    selectedProjectName () {
      return this.$store.getters.getSelectedProjectName
    },
    user () {
      return this.$store.getters.getUser
    },
    isLoading () {
      return this.$store.getters.getIsLoading
    },
    filteredProjectsList () {
      let res = this.managedProjects
      if (this.search) {
        const rg = new RegExp(this.search, 'gi')
        res = this.managedProjects.filter(item => {
          rg.lastIndex = 0
          return rg.test(item.Description)
        })
      }
      return res.sort((a, b) => {
        const valA = a.Description.toUpperCase()
        const valB = b.Description.toUpperCase()
        if (valA < valB) return -1
        if (valA > valB) return 1
        return 0
      })
    }
  },
  mounted () {
    this.getProjectsList()
  },
  destroyed () {
    this.$store.dispatch('removeUsersOnProject')
    this.$store.dispatch('removeParentTasksOnProject')
  },
  methods: {
    getDetailInformation () {
      this.gettingInformation = true
      this.$store.dispatch('showDetailsDialog', {
        show: {
          show: true,
          repByProject: true
        }
      })
    },
    setProject (project, removeUsersAndParentTask) {
      if (this.selectMultiple) return
      if (!(project.Project_ID === this.selectedProject)) {
        this.$store.dispatch('setCurrentTasksList', { tasksList: [] })
        this.$store.dispatch('setSelectedProject', { selectedProject: project.Project_ID })
        this.$store.dispatch('setSelectedProjectName', { selectedProjectName: project.Description })
        if (removeUsersAndParentTask && !this.gettingInformation) {
          this.$store.dispatch('removeUsersOnProject')
          this.$store.dispatch('removeParentTasksOnProject')
        }
        this.gettingInformation = false
      }
    },
    setMultipleProjects () {
      this.$store.dispatch('setSelectedProject', { selectedProject: this.selectedProjects })
      this.$store.dispatch('updateTasks', { update: true })
    },
    getProjectsList () {
      this.axios.get('/api/managedprojects', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        this.managedProjects = response.data
        setTimeout(() => {
          if (this.managedProjects.length && this.managedProjects[0].Project_ID !== this.selectedProject) {
            this.setProject(this.managedProjects[0])
          }
          this.updateKey++
        })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    }
  }
}
</script>
